<template>
  <Drawer
    :on-close="closePanel"
    :close-title="I18n.t('editor.modal_close')"
    close-icon-position="floating"
    class="designDrawer"
  >
    <template #actions>
      <CanvaContentImage
        :image="store.selectedImage"
        :src="designContentImage"
        alt="Add text or elements to your image in Canva"
        :getDataURL="props.getDataURL"
        :canvaVariant="CanvaVariant.INLINE_EDITOR_DEFAULT"
        :canvaCtaIdentifier="CanvaCTAIdentifier.ADD_TEXT_VISUAL"
        :stage="props.stage"
        :stageHd="props.stageHd"
        :persistentStore="props.persistentStore"
        :refreshAllHdLayers="props.refreshAllHdLayers"
      />
    </template>

    <template #content>
      <div class="flex flex-col gap-2 w-full">
        <CanvaCtaNew
          :image="store.selectedImage"
          :persistentStore="props.persistentStore"
          :refreshAllHdLayers="props.refreshAllHdLayers"
          :stage="props.stage"
          :stageHd="props.stageHd"
          :getDataURL="props.getDataURL"
          :canvaVariant="CanvaVariant.INLINE_EDITOR_DEFAULT"
          :canvaCtaIdentifier="CanvaCTAIdentifier.ADD_TEXT"
          :icon="IconText"
          :label="I18n.t('canva_cta.flows.add_text_to_image')"
        />
        <CanvaCtaNew
          :image="store.selectedImage"
          :persistentStore="props.persistentStore"
          :refreshAllHdLayers="props.refreshAllHdLayers"
          :stage="props.stage"
          :stageHd="props.stageHd"
          :getDataURL="props.getDataURL"
          :canvaVariant="CanvaVariant.INLINE_EDITOR_DEFAULT"
          :canvaCtaIdentifier="CanvaCTAIdentifier.ADD_ELEMENTS"
          :icon="IconElements"
          :label="I18n.t('canva_cta.flows.add_elements')"
        />
        <CanvaCtaNew
          :image="store.selectedImage"
          :persistentStore="props.persistentStore"
          :refreshAllHdLayers="props.refreshAllHdLayers"
          :stage="props.stage"
          :stageHd="props.stageHd"
          :getDataURL="props.getDataURL"
          :canvaVariant="CanvaVariant.INLINE_EDITOR_DEFAULT"
          :canvaCtaIdentifier="CanvaCTAIdentifier.USE_TEMPLATE"
          :icon="IconDesign"
          :label="I18n.t('canva_cta.flows.use_template')"
        />
      </div>
    </template>
  </Drawer>
</template>

<script setup lang="ts">
import "@/src/i18n";

import { inject } from "vue";

import { Drawer } from "prism";

import CanvaCtaNew from "@/components/canva_cta_new.vue";
import { ElementsIcon as IconElements } from "prism";

import { useEditorStore } from "@/stores/editor_store";
import { Stage } from "konva/lib/Stage";
import { CanvaCTAIdentifier, CanvaVariant } from "@/composables/canva_link_builder";
import designContentImage from "@assets/images/inline-editor/design_panel_content.png";
import IconText from "@/components/upload/editor_components/side_panel_icons/icon-text.vue";
import IconDesign from "@/components/upload/editor_components/side_panel_icons/icon-design.vue";
import CanvaContentImage from "@/components/upload/canva_content_image.vue";
import { I18n as I18nType } from "i18n-js";
import { PersistentStore } from "@/stores/persistent_store";
import { Image } from "@/modules/internal_api/image";

const I18n: I18nType = inject("I18n");

const store = useEditorStore();

interface DesignPanelProps {
  editor: HTMLElement; // TODO look into removing
  stage: Stage;
  stageHd: Stage;
  persistentStore: PersistentStore;
  refreshAllHdLayers: (image: Image) => Promise<void>;
  getDataURL: Function;
}

const props = defineProps<DesignPanelProps>();

const emit = defineEmits<{
  (e: "closePanel"): void;
}>();

const closePanel = () => {
  emit("closePanel");
};
</script>

<style scoped lang="scss">
.designDrawer {
  @media (min-width: 768px) {
    width: 24.25rem;
  }
}
</style>
